import { render, staticRenderFns } from "./resumo.vue?vue&type=template&id=379705dc"
import script from "./resumo.vue?vue&type=script&lang=js"
export * from "./resumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports